// A Collab Pricing quote's link to the Project Tracker (CpTrackerLink.jsx, Amy 30/10 · Max 31/10/2026).
const en = {
  title: 'Project Tracker',
  notLinked: 'Not linked yet — link it and the Costing column of the SKUs follows this quote.',
  linkedCount: '{{n}} of {{total}} SKU line(s) linked',
  link: 'Link to a project',
  change: 'Change link',
  noSku: '— not in the tracker —',
  note: 'Costing in the Project Tracker: Draft = In Progress, Pending = Waiting Manager / CEO Approval, Approved = Complete.',
  searchPh: 'Find a project: PRJ number or name',
  nSkus: '{{n}} SKU(s)',
  noneFound: 'No project found.',
  other: 'Another project',
  quoteLine: 'Line in this quote',
  trackerSku: 'SKU in the Project Tracker',
  save: 'Save link',
  cancel: 'Cancel',
  unlink: 'Remove link',
  saveFailed: 'Could not save the link.',
};

const ko = {
  title: '프로젝트 트래커',
  notLinked: '아직 연결되지 않았어요 — 연결하면 SKU의 Costing 열이 이 견적을 따라가요.',
  linkedCount: 'SKU {{total}}줄 중 {{n}}줄 연결됨',
  link: '프로젝트에 연결',
  change: '연결 변경',
  noSku: '— 트래커에 없음 —',
  note: '프로젝트 트래커의 Costing: 초안 = In Progress, 승인 대기 = Waiting Manager / CEO Approval, 승인 = Complete.',
  searchPh: '프로젝트 찾기: PRJ 번호 또는 이름',
  nSkus: 'SKU {{n}}개',
  noneFound: '프로젝트가 없어요.',
  other: '다른 프로젝트',
  quoteLine: '이 견적의 줄',
  trackerSku: '프로젝트 트래커의 SKU',
  save: '연결 저장',
  cancel: '취소',
  unlink: '연결 해제',
  saveFailed: '연결을 저장하지 못했어요.',
};

const vi = {
  title: 'Project Tracker',
  notLinked: 'Chưa liên kết — liên kết xong thì cột Costing của các SKU sẽ theo báo giá này.',
  linkedCount: 'Đã liên kết {{n}}/{{total}} dòng SKU',
  link: 'Liên kết với project',
  change: 'Đổi liên kết',
  noSku: '— không có trong tracker —',
  note: 'Costing trên Project Tracker: Nháp = In Progress, Chờ duyệt = Waiting Manager / CEO Approval, Đã duyệt = Complete.',
  searchPh: 'Tìm project: số PRJ hoặc tên',
  nSkus: '{{n}} SKU',
  noneFound: 'Không tìm thấy project.',
  other: 'Project khác',
  quoteLine: 'Dòng trong báo giá',
  trackerSku: 'SKU trên Project Tracker',
  save: 'Lưu liên kết',
  cancel: 'Hủy',
  unlink: 'Bỏ liên kết',
  saveFailed: 'Không lưu được liên kết.',
};

const zh = {
  title: '项目跟踪',
  notLinked: '尚未关联 — 关联后，各 SKU 的 Costing 列将跟随此报价。',
  linkedCount: '已关联 {{n}}/{{total}} 行 SKU',
  link: '关联到项目',
  change: '更改关联',
  noSku: '— 不在跟踪表中 —',
  note: '项目跟踪中的 Costing：草稿 = In Progress，待审批 = Waiting Manager / CEO Approval，已批准 = Complete。',
  searchPh: '查找项目：PRJ 编号或名称',
  nSkus: '{{n}} 个 SKU',
  noneFound: '未找到项目。',
  other: '其他项目',
  quoteLine: '报价中的行',
  trackerSku: '项目跟踪中的 SKU',
  save: '保存关联',
  cancel: '取消',
  unlink: '取消关联',
  saveFailed: '无法保存关联。',
};

const dictionary = { ns: 'xCpLink', en, ko, vi, zh };

export default dictionary;
